import {
  CircularProgress,
  CircularProgressLabel,
  Tooltip,
} from '@chakra-ui/react';
import {
  compareEnum,
  ensureEnumNumber,
} from '@texas/utils/helpers/enumHelpers';
import { ProductApprovalState } from '@texas/api/endpoints/productApprovalsApi';
import { SampleLifecycle } from './types';

type Variant = 'default' | 'tiny';

const totalSteps = 5;

export function SampleProgress({
  state,
  paState,
  variant = 'default',
}: {
  state: SampleLifecycle;
  paState: ProductApprovalState | undefined;
  variant?: Variant;
}) {
  let progress = 0;

  switch (ensureEnumNumber(SampleLifecycle, state)) {
    case SampleLifecycle.SampleRejected:
    case SampleLifecycle.SampleCancelled:
    case SampleLifecycle.SampleAccepted:
    case SampleLifecycle.Nothing:
      progress = 0;
      break;
    case SampleLifecycle.SampleBeingPreparedAtSupplier:
      progress = Math.floor((1 / totalSteps) * 100);
      break;
    case SampleLifecycle.SampleBeingPreparedReadySampleDatePassed:
      progress = Math.floor((1 / totalSteps) * 100);
      break;

    case SampleLifecycle.SampleReceivedFromSupplier:
      progress = Math.floor((2 / totalSteps) * 100);
      break;
    case SampleLifecycle.SampleInInternalTransportRequestAwaitingDispatch:
      progress = Math.floor((3 / totalSteps) * 100);
      break;
    case SampleLifecycle.SampleInInternalTransportRequestAwaitingShipment: {
      progress = Math.floor((3 / totalSteps) * 100);
      break;
    }
    case SampleLifecycle.SampleInInternalTransportRequestDispatched: {
      progress = Math.floor((3 / totalSteps) * 100);
      break;
    }
    case SampleLifecycle.SampleUnhandled:
      progress = Math.floor((3 / totalSteps) * 100);
      break;
    case SampleLifecycle.SampleLost: {
      progress = 0;
      break;
    }

    case SampleLifecycle.SampleInBrandTransportRequestAwaitingShipment: {
      progress = Math.floor((4 / totalSteps) * 100);
      break;
    }
    case SampleLifecycle.SampleInBrandTransportRequestAwaitingDispatch: {
      progress = Math.floor((4 / totalSteps) * 100);
      break;
    }
    case SampleLifecycle.SampleInBrandTransportRequestDispatched: {
      progress = Math.floor((4 / totalSteps) * 100);
      break;
    }
    case SampleLifecycle.SampleReceivedAtBrand: {
      progress = Math.floor((4 / totalSteps) * 100);
      break;
    }
    case SampleLifecycle.SampleOnHold: {
      progress = Math.floor((4 / totalSteps) * 100);
      break;
    }
  }

  if (
    compareEnum(ProductApprovalState, paState, ProductApprovalState.Accepted)
  ) {
    progress = 100;
  }

  if (variant == 'tiny') {
    return (
      <Tooltip label={`${progress}%`}>
        <CircularProgress
          value={progress}
          color="orange.400"
          size="22px"
          thickness="10px"
        />
      </Tooltip>
    );
  }

  return (
    <CircularProgress
      value={progress}
      color="orange.400"
      size="40px"
      thickness="12px"
      trackColor="gray.100"
    >
      <CircularProgressLabel fontWeight="bold">
        {progress}%
      </CircularProgressLabel>
    </CircularProgress>
  );
}
